if (!customElements.get('abok-countdown')) {
  customElements.define(
    'abok-countdown',
    class AbokCountdown extends HTMLElement {
      connectedCallback() {
        this.endAt = Date.parse(this.dataset.endAt || '');
        this.parts = {
          days: this.querySelector('[data-countdown-days]'),
          hours: this.querySelector('[data-countdown-hours]'),
          minutes: this.querySelector('[data-countdown-minutes]'),
          seconds: this.querySelector('[data-countdown-seconds]'),
        };

        if (!Number.isFinite(this.endAt)) return;
        this.render();
        if (this.endAt > Date.now()) this.timer = window.setInterval(() => this.render(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      render() {
        const remaining = Math.max(0, this.endAt - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor((totalSeconds % 86400) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60,
        };

        Object.entries(values).forEach(([key, value]) => {
          if (this.parts[key]) this.parts[key].textContent = String(value).padStart(2, '0');
        });

        if (remaining === 0) {
          window.clearInterval(this.timer);
          this.dataset.expired = 'true';
        }
      }
    }
  );
}
